import { ColorClass, Icon, IconIdentifier, Tooltip } from '@aus-platform/design-system';
import React from 'react';
import { ClusterStatus } from 'shared/api';
import type { HeapClusterCalculationStatusProps } from './types';
import { HeapCalculationStatusMessage } from './enums';

export const HeapClusterCalculationStatus: React.FC<
  HeapClusterCalculationStatusProps
> = ({
  status,
  numberOfCalculatedHeaps,
  numberOfHeaps,
  failureReason,
}) => {
  if (status !== ClusterStatus.Failed) {
    return null;
  }

  // Variables.
  const isAllFailed = numberOfCalculatedHeaps === 0;

  const hoverMessage = isAllFailed
    ? (failureReason ?? HeapCalculationStatusMessage.Failed)
    : HeapCalculationStatusMessage.Incomplete;

  return (
    <div className="heap-list__modal-sub-header__heap-count">
      {isAllFailed
        ? 'Calculation failed'
        : `${numberOfCalculatedHeaps}/${numberOfHeaps} calculated`}
      <Tooltip hoverText={hoverMessage}>
        <Icon
          className="heap-list__modal-sub-header__heap-count-icon"
          identifier={IconIdentifier.ExclamationCircle}
          size={20}
          colorClass={ColorClass.Error400}
        />
      </Tooltip>
    </div>
  );
};
